module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-locate"
  }, [(false) ? _c('div', {
    staticClass: "container slick-wrapper",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      key: image.title,
      attrs: {
        "caption": image.title,
        "href": image.src,
        "src": image.src
      }
    }, [(_vm.isDesktop) ? _c('img', {
      attrs: {
        "src": image.src
      }
    }) : _c('img', {
      attrs: {
        "src": image.srcMobile
      }
    })])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.locations && _vm.locations.length > 0) ? _c('div', {
    staticClass: "container container-tabs",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', _vm._l((_vm.locations), function(location, index) {
    return _c('li', {
      class: {
        'is-active': _vm.selectedLocation === index
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectedLocation = index
        }
      }
    }, [_c('span', {
      staticClass: "is-smallscreen"
    }, [_vm._v(_vm._s(location.shortname))]), _c('span', {
      staticClass: "is-hidden-smallscreen"
    }, [_vm._v(_vm._s(location.location.place))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locations[_vm.selectedLocation] ? _vm.locations[_vm.selectedLocation].name : 'invalid'))])])]) : _vm._e(), _vm._v(" "), (_vm.locations && _vm.locations[_vm.selectedLocation] && !_vm.locations[_vm.selectedLocation].removed && _vm.locations.length > 0) ? _c('div', {
    staticClass: "container container-map map",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [(false) ? _c('div', {
    staticClass: "search"
  }, [_c('gmap-autocomplete', {
    attrs: {
      "value": _vm.locations[_vm.selectedLocation].location.location,
      "placeholder": "Enter location"
    },
    on: {
      "place_changed": _vm.setPlace
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "placecard__container",
    staticStyle: {
      "z-index": "2"
    }
  }, [_c('div', {
    staticClass: "placecard__left"
  }, [_c('p', {
    staticClass: "placecard__business-name"
  }, [_vm._v(_vm._s(_vm.locations[_vm.selectedLocation].name))]), _vm._v(" "), _c('p', {
    staticClass: "placecard__info"
  }, [_vm._v(_vm._s(_vm.locations[_vm.selectedLocation].location.location))]), _vm._v(" "), _c('a', {
    staticClass: "placecard__view-large",
    attrs: {
      "href": _vm.locations[_vm.selectedLocation].location.link,
      "target": "_blank",
      "id": "A_41"
    }
  }, [_vm._v("View larger map")])]), _vm._v(" "), _c('div', {
    staticClass: "placecard__right"
  }, [_c('a', {
    staticClass: "placecard__direction-link",
    attrs: {
      "href": _vm.locations[_vm.selectedLocation].location.direction,
      "target": "_blank",
      "id": "A_9"
    }
  }, [_c('div', {
    staticClass: "placecard__direction-icon"
  }), _vm._v("\n          Directions\n        ")])])]), _vm._v(" "), _c('gmap-map', {
    staticClass: "gmap",
    attrs: {
      "center": _vm.locations[_vm.selectedLocation].position,
      "options": {
        styles: _vm.mapStyle,
        /* disableDefaultUI: true, */ scrollwheel: false,
        navigationControl: true,
        mapTypeControl: false,
        scaleControl: true,
        zoomControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: true
      },
      "zoom": _vm.locations[_vm.selectedLocation].zoom
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.locations[_vm.selectedLocation].position,
      "icon": _vm.mapIcon,
      "place": _vm.selectedPlace
    }
  })], 1), _vm._v(" "), (false) ? _c('gmap-street-view-panorama', {
    staticClass: "pano",
    attrs: {
      "position": _vm.locations[_vm.selectedLocation].position,
      "pov": {
        heading: 0,
        pitch: 10
      },
      "zoom": 1
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.locations && _vm.locations[_vm.selectedLocation] && !_vm.locations[_vm.selectedLocation].removed && _vm.locations.length > 0) ? _c('div', {
    staticClass: "container container-content",
    staticStyle: {
      "margin-top": "1rem"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3 container-apps"
  }, [_c('div', {
    staticClass: "waze",
    staticStyle: {
      "display": "inline"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.wazeUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "border": "1px solid lightgray",
      "border-radius": "20px",
      "padding": "8px",
      "background-color": "white"
    },
    attrs: {
      "src": require("../assets/waze.svg"),
      "width": "60",
      "data-pin-nopin": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "google-map",
    staticStyle: {
      "display": "inline"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.googleMapsUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-map-marker",
    staticStyle: {
      "border": "1px solid lightgray",
      "border-radius": "20px",
      "padding": "14px 20px",
      "background-color": "white",
      "margin-left": "15px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('ul', {
    staticClass: "info-list"
  }, [_c('li', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "context"
  }, [_vm._v("name")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.locations[_vm.selectedLocation].company)
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "context"
  }, [_vm._v("address")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.locations[_vm.selectedLocation].address)
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "context"
  }, [_vm._v("phone")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.locations[_vm.selectedLocation].phone)
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "context"
  }, [_vm._v("email")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.getEmailTags(_vm.locations[_vm.selectedLocation].email))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "context"
  }, [_vm._v("operation")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.locations[_vm.selectedLocation].operation)
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.locations && _vm.locations[_vm.selectedLocation] && _vm.locations[_vm.selectedLocation].removed && _vm.locations.length > 0) ? _c('div', {
    staticClass: "container container-content",
    staticStyle: {
      "margin-top": "1rem"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "margin-top": "3em",
      "margin-bottom": "1em"
    }
  }, [_vm._v("We have moved!")]), _vm._v(" "), _c('span', [_vm._v("Please visit us at our "), _c('a', {
    staticStyle: {
      "border-bottom": "1px solid black"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.onReturnMainShowroom($event)
      }
    }
  }, [_vm._v("Main Showroom")]), _vm._v(" for now.")])])])])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "container container-content",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Locate")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e8b5a39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LocateUs.vue
// module id = 734
// module chunks = 1